/**
 * Dropdown Menu Component
 * Reusable dropdown menu for desktop header
 */
import React, { useState, useRef, useEffect } from 'react';
import './Dropdown.css';

interface DropdownItem {
  label: string;
  icon: string;
  onClick: () => void;
  disabled?: boolean;
}

interface DropdownProps {
  trigger: React.ReactNode;
  items: DropdownItem[];
  align?: 'left' | 'right';
  header?: React.ReactNode; // volitelny nekliknutelny nadpis (napr. prihlaseny pouzivatel)
}

export const Dropdown: React.FC<DropdownProps> = ({ trigger, items, align = 'right', header }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  console.log('🔧 Dropdown: items =', items);
  console.log('🔧 Dropdown: items.length =', items.length);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleItemClick = (item: DropdownItem) => {
    if (!item.disabled) {
      item.onClick();
      setIsOpen(false);
    }
  };

  return (
    <div className="dropdown" ref={dropdownRef}>
      <div
        className="dropdown-trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        {trigger}
      </div>
      {isOpen && (
        <div className={`dropdown-menu ${align}`}>
          {header && <div className="dropdown-header">{header}</div>}
          {items.map((item, index) => {
            console.log('🔧 Dropdown: rendering item', index, item);
            return (
              <button
                key={index}
                className={`dropdown-item ${item.disabled ? 'disabled' : ''}`}
                onClick={() => handleItemClick(item)}
                disabled={item.disabled}
              >
                <span className="dropdown-item-icon">{item.icon}</span>
                <span className="dropdown-item-label">{item.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
